export default __webpack_public_path__ + "static/media/cloud.06937d87.svg";